import { useAppStore } from '@/app/stores/app.store.js';

/**
 * Mobile sidebar auto-close guard
 *
 * This afterEach hook automatically closes the mobile sidebar on route navigation,
 * ensuring a consistent user experience when navigating between pages
 */
export function closeMobileSidebar() {
    const appStore = useAppStore();
    appStore.sidebarOpen = false;
    appStore.contentSidebarOpen = false;
}
